import { CommonModule, isPlatformBrowser } from "@angular/common";
import { Component, OnInit, AfterViewInit, Inject, PLATFORM_ID } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterLink } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { EthPricePipe } from "../../../pipes/eth-price.pipe";
import { RarityNamePipe } from "../../../pipes/rarity-name.pipe";
import { TimeAgoPipe } from "../../../pipes/time-ago.pipe";
import { CreatureLiteWebDto } from "../../../dtos/creature.lite.web.dto";
import { CreatureType } from "../../../enums/creature.type";
import { CreaturesService } from "../../../services/creatures.service";
import { StatisticsService } from "../../../services/statistics.service";
import { RarityType } from "../../../enums/rarity.type";

@Component({
    selector: 'info-sales',
    templateUrl: './info-sales.component.html',
    styleUrl: './info-sales.component.scss',
    imports: [
        CommonModule,
        RouterLink,
        RarityNamePipe,
        EthPricePipe,
        TimeAgoPipe,
        TranslateModule,
        FormsModule
    ],
})
export class InfoSalesComponent implements OnInit, AfterViewInit {

    public lang: string | null = null;

    public readonly creatureType: typeof CreatureType = CreatureType;
    public readonly rarityType: typeof RarityType = RarityType;

    public allTopSales: CreatureLiteWebDto[] = [];
    public topSales: CreatureLiteWebDto[] = [];
    public topSalesFilter: {
        periodInDays: number | null;
        type: CreatureType | null;
    } = {
            periodInDays: null,
            type: null,
        };

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private readonly statisticsService: StatisticsService,
        private readonly creaturesService: CreaturesService,
        private readonly translateService: TranslateService,
    ) {
        this.lang = this.translateService.currentLang;
        this.translateService.onLangChange.subscribe((event) => {
            this.lang = event.lang;
        })
    }

    ngOnInit(): void {
        [
            CreatureType.Moonbits,
            CreatureType.Oregon,
            CreatureType.Sharkman,
            CreatureType.Zunnie,
        ].forEach((type) => {
            this.statisticsService.getTopSalesCreatures(type).subscribe({
                next: (data) => {

                    let creatures = data.creatures;
                    let tradeListings = data.tradeListings;

                    creatures = creatures.map((creature) => {
                        const tradeListing = tradeListings.find((listing) => listing.creatureId === creature.id);
                        if (tradeListing) {
                            creature.tradeListing = tradeListing;
                        }
                        return creature;
                    });

                    this.allTopSales = [...this.allTopSales, ...creatures];
                    this.updateTopSalesFilter();
                },
                error: (err) => {
                    console.error('Failed to load creatures:', err);
                },
            });
        });
    }

    ngAfterViewInit(): void {
        
    }

    private uiScriptIsLoaded = false;
    public updateTopSalesFilter() {
        this.topSales = this.allTopSales.filter((creature) => {
            if (this.topSalesFilter.periodInDays) {
                const now = new Date();
                const listedDate = new Date(creature.tradeListing?.buyghtAt!);
                const diffTime = Math.abs(now.getTime() - listedDate.getTime());
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                return diffDays <= this.topSalesFilter.periodInDays;
            }
            return true;
        });

        if (this.topSalesFilter.type) {
            this.topSales = this.topSales.filter((creature) => creature.type == this.topSalesFilter.type);
        }

        this.topSales = this.topSales.splice(0, 9);

        if (this.topSales.length > 0) {
            setTimeout(() => {
                if (isPlatformBrowser(this.platformId) && !this.uiScriptIsLoaded) {
                this.uiScriptIsLoaded = true;
                const script = document.createElement('script');
                script.src = '/assets/js/index.script.js';
                script.type = 'text/javascript';
                script.async = true;
                document.body.appendChild(script);
            }
            }, 250);
        }
    }

    public updateTopSalesFilterType(type: string) {
        if (type == 'null'){
            this.topSalesFilter.type = null;
        } else {
            this.topSalesFilter.type = parseInt(type) as CreatureType;
        }
        
        if (this.topSalesFilter.type as any == 'null'){
            this.topSalesFilter.type = null;
        }

        this.updateTopSalesFilter();
    }

    public updateTopSalesFilterPeriod(period: string) {
        if (period == 'null'){
            this.topSalesFilter.periodInDays = null;
        } else {
            this.topSalesFilter.periodInDays = parseInt(period);
        }

        if (this.topSalesFilter.type as any == 'null'){
            this.topSalesFilter.type = null;
        }
        
        this.updateTopSalesFilter();
    }
}